module.exports = __webpack_public_path__ + "static/img/7.8a28b61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/7.png
// module id = MQkt
// module chunks = 0